import { reviewApproveMap } from '@/api';
import { post } from '@/common/request';


export interface SearchParams {
  tenantPlaceName?: string;	 // 项目名称
  tenantPlaceId?: number; // 场地ID
  categoryIdList?:	Array<number>;	// 类目id集合
  provinceId?: number; // 省id
  cityId?: number; // 城市id
  districtId?: number; // 区域id
  employeeIdList?: Array<number>; // 复盘跟进人id集合
  status?: Status; // 审核状态
}

type Status = 1 | 2 | 3 // 1-待审核 2-审核通过 3-审核拒绝

interface ReviewApproveInfo {
  id?: number; // 主键
  placeId:	number; // 场地id
  placeName?:	string; // 项目名称
  address?: string; // 地址
  category?: string; // 类目
  priority?: any	 // 复盘优先级
  follower?: string	 // 跟进人
  createdAt?: string	 // 创建时间
  permissions?: any[] // 按钮列表
}
interface Respone {
  totalNum?: number;
  pageSize?: number;
  pageNum?: number;
  objectList?: ReviewApproveInfo[];
}



class LabelAuditStore {
  getList(page: number, size: number, searchParams: SearchParams): Promise<Respone> {
    return post(reviewApproveMap.get('pageList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  detail(id: number): Promise<{id: number}> {
    return post(reviewApproveMap.get('detail'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  pass(params: any) {
    return post(reviewApproveMap.get('pass'), params, { proxyApi: '/resserv', needHint: true });
  }
  reject(id: number, reason:string) : Promise<{id: number, reason:string}> {
    return post(reviewApproveMap.get('reject'), { id, reason }, { proxyApi: '/resserv', needHint: true });
  }
}


export default new LabelAuditStore();
